import { render, staticRenderFns } from "./MenuAuditLog.vue?vue&type=template&id=4e658d21&scoped=true"
import script from "./MenuAuditLog.vue?vue&type=script&lang=js"
export * from "./MenuAuditLog.vue?vue&type=script&lang=js"
import style0 from "./MenuAuditLog.vue?vue&type=style&index=0&id=4e658d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e658d21",
  null
  
)

export default component.exports